<div #chatContent class="chat-content" cdkScrollable (scroll)="onScroll()">
  <ng-content />
</div>

<div class="new-messages-marker" [class.show]="showNewMessageIndicator">
  <div class="new-messages-marker-content">
    <button mat-flat-button color="primary" (click)="scrollToBottom()">
      <mat-icon>arrow_downward</mat-icon>
      New messages received
    </button>
  </div>
</div>
